// eslint-disable-next-line import/prefer-default-export
export const CREATIVE_FILE_TYPES = {
  IMAGE: 'Image',
  VIDEO: 'Video',
};
